const states = [
  { name: 'Alabama', shortcode: 'AL' },
  { name: 'Alaska', shortcode: 'AK' },
  { name: 'Arizona', shortcode: 'AZ' },
  { name: 'Arkansas', shortcode: 'AR' },
  { name: 'California', shortcode: 'CA' },
  { name: 'Colorado', shortcode: 'CO' },
  { name: 'Connecticut', shortcode: 'CT' },
  { name: 'Delaware', shortcode: 'DE' },
  { name: 'Florida', shortcode: 'FL' },
  { name: 'Georgia', shortcode: 'GA' },
  { name: 'Hawaii', shortcode: 'HI' },
  { name: 'Idaho', shortcode: 'ID' },
  { name: 'Illinois', shortcode: 'IL' },
  { name: 'Indiana', shortcode: 'IN' },
  { name: 'Iowa', shortcode: 'IA' },
  { name: 'Kansas', shortcode: 'KS' },
  { name: 'Kentucky', shortcode: 'KY' },
  { name: 'Louisiana', shortcode: 'LA' },
  { name: 'Maine', shortcode: 'ME' },
  { name: 'Maryland', shortcode: 'MD' },
  { name: 'Massachusetts', shortcode: 'MA' },
  { name: 'Michigan', shortcode: 'MI' },
  { name: 'Minnesota', shortcode: 'MN' },
  { name: 'Mississippi', shortcode: 'MS' },
  { name: 'Missouri', shortcode: 'MO' },
  { name: 'Montana', shortcode: 'MT' },
  { name: 'Nebraska', shortcode: 'NE' },
  { name: 'Nevada', shortcode: 'NV' },
  { name: 'New Hampshire', shortcode: 'NH' },
  { name: 'New Jersey', shortcode: 'NJ' },
  { name: 'New Mexico', shortcode: 'NM' },
  { name: 'New York', shortcode: 'NY' },
  { name: 'North Carolina', shortcode: 'NC' },
  { name: 'North Dakota', shortcode: 'ND' },
  { name: 'Ohio', shortcode: 'OH' },
  { name: 'Oklahoma', shortcode: 'OK' },
  { name: 'Oregon', shortcode: 'OR' },
  { name: 'Pennsylvania', shortcode: 'PA' },
  { name: 'Rhode Island', shortcode: 'RI' },
  { name: 'South Carolina', shortcode: 'SC' },
  { name: 'South Dakota', shortcode: 'SD' },
  { name: 'Tennessee', shortcode: 'TN' },
  { name: 'Texas', shortcode: 'TX' },
  { name: 'Utah', shortcode: 'UT' },
  { name: 'Vermont', shortcode: 'VT' },
  { name: 'Virginia', shortcode: 'VA' },
  { name: 'Washington', shortcode: 'WA' },
  { name: 'West Virginia', shortcode: 'WV' },
  { name: 'Wisconsin', shortcode: 'WI' },
  { name: 'Wyoming', shortcode: 'WY' },
]

const statesByName = states.reduce((acc, state) => {
  acc[state.name] = state
  return acc
}, {})

const statesByShortcode = states.reduce((acc, state) => {
  acc[state.shortcode] = state
  return acc
}, {})

const findStateByName = (name) => statesByName[name]

const findStateByShortcode = (shortcode) => statesByShortcode[shortcode]

module.exports = { states, findStateByName, findStateByShortcode }
